import manifest from "../manifest.template.json";
export var PLUGIN_ID = manifest.id;
